/* ==========================================================================
   Plant Store <> UnfoldCRO — build-your-own bundle picker

   Tracks the picks, keeps the slots and totals in step, and posts the whole
   selection in one /cart/add.js call so the drawer opens once.

   The discount shown is display only. Checkout charges what Shopify's own
   discount rules say, so the matching automatic discount has to exist in
   Admin — this never sends a price of its own.
   ========================================================================== */
(function () {
  'use strict';

  function money(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return (format || '{{amount}}').replace(
      /\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/g,
      function (match) {
        return match.indexOf('no_decimals') > -1 ? whole : whole + '.' + parts[1];
      }
    );
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ufc-byob]'), function (root) {
      if (root.ufcByobBound) return;
      root.ufcByobBound = true;
      initOne(root);
    });
  }

  function initOne(root) {
    var strings = {};
    try {
      strings = JSON.parse(root.querySelector('[data-ufc-byob-strings]').textContent);
    } catch (e) {
      return;
    }

    var need = parseInt(root.getAttribute('data-count'), 10) || 3;
    var pct = parseFloat(root.getAttribute('data-discount')) || 0;

    // Two offers share this picker. "percent" takes a percentage off a fixed
    // number of picks; "flat" prices every item the same once a quantity is
    // reached. Sorted ascending so the last rung cleared is the live one.
    var mode = root.getAttribute('data-mode');
    var flat = mode === 'flat';
    var percentLadder = mode === 'percent_tiers';
    var ladder = flat || percentLadder;
    var tiers = (strings.tiers || [])
      .filter(function (t) {
        return t && t.min > 0;
      })
      .sort(function (a, b) {
        return a.min - b.min;
      });

    var picks = root.querySelectorAll('[data-ufc-byob-pick]');
    var slots = root.querySelectorAll('[data-ufc-byob-slot]');
    var tierEls = root.querySelectorAll('[data-ufc-byob-tier]');
    var offLabelEl = root.querySelector('[data-ufc-byob-off-label]');
    var countEl = root.querySelector('[data-ufc-byob-count]');
    var subEl = root.querySelector('[data-ufc-byob-subtotal]');
    var offEl = root.querySelector('[data-ufc-byob-off]');
    var totalEl = root.querySelector('[data-ufc-byob-total]');
    var addBtn = root.querySelector('[data-ufc-byob-add]');

    // One entry per unit, not per product: a product taken three times appears
    // three times. Everything downstream -- the slots, the rung the basket has
    // reached, the subtotal -- already counts entries, so quantities cost those
    // nothing. Only the cart post has to fold them back up.
    // Folding the summary away on a phone. Nothing else depends on it, so it is
    // just a class on the card plus the state on the button.
    var summary = root.querySelector('.ufc-byob__summary');
    var summaryToggle = root.querySelector('[data-ufc-byob-toggle]');
    var onPhone = !!(window.matchMedia && window.matchMedia('(max-width: 989px)').matches);
    var openedOnFirstPick = false;

    function openSummaryOnFirstPick() {
      if (openedOnFirstPick || !onPhone || !summary || !summaryToggle) return;
      openedOnFirstPick = true;
      summary.classList.remove('is-collapsed');
      summaryToggle.setAttribute('aria-expanded', 'true');
    }

    if (summary && summaryToggle) {
      if (onPhone) {
        summary.classList.add('is-collapsed');
        summaryToggle.setAttribute('aria-expanded', 'false');
      }
      summaryToggle.addEventListener('click', function () {
        var collapsed = summary.classList.toggle('is-collapsed');
        summaryToggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    }

    var chosen = [];
    var allowQty = strings.allowQty === true;
    var openEnded = ladder || strings.allowExtra === true;
    var slotHost = root.querySelector('[data-ufc-byob-slots]');

    var lastCount = 0;

    function revealLastSlot(count) {
      if (!slotHost || count <= lastCount) {
        lastCount = count;
        return;
      }
      lastCount = count;
      if (slotHost.scrollWidth <= slotHost.clientWidth) return;
      slotHost.scrollLeft = slotHost.scrollWidth;
    }

    function ensureSlots(wanted) {
      if (!slotHost) return;
      var have = slotHost.querySelectorAll('[data-ufc-byob-slot]').length;
      for (var i = have; i < wanted; i++) {
        var slot = document.createElement('span');
        slot.className = 'ufc-byob__slot';
        slot.setAttribute('data-ufc-byob-slot', String(i));
        slot.innerHTML = '<span aria-hidden="true">+</span>';
        slotHost.appendChild(slot);
      }
    }

    function qtyOf(id) {
      return chosen.filter(function (item) {
        return item.id === id;
      }).length;
    }

    function fill(text, map) {
      return Object.keys(map).reduce(function (out, key) {
        return out.split('[' + key + ']').join(map[key]);
      }, text || '');
    }

    // The best rung the basket has cleared, or null while it is short of the
    // first one.
    function tierFor(count) {
      var hit = null;
      tiers.forEach(function (t) {
        if (count >= t.min) hit = t;
      });
      return hit;
    }

    function sync() {
      var count = chosen.length;
      if (count > 0) openSummaryOnFirstPick();
      var subtotal = chosen.reduce(function (sum, item) {
        return sum + item.price;
      }, 0);

      var tier = ladder ? tierFor(count) : null;
      var off;
      if (percentLadder) {
        off = tier ? Math.round((subtotal * tier.percent) / 100) : 0;
      } else if (flat) {
        // Every item takes the rung's price, so the saving is whatever that
        // undercuts the basket by. Clamped at zero: a rung priced above the
        // regular prices should never read as a negative discount.
        off = tier ? Math.max(0, subtotal - tier.each * count) : 0;
      } else {
        // Rounded once on the whole basket, not per line, so the figure matches
        // an order-level automatic discount rather than drifting a rupee or two.
        var qualifies = openEnded ? count >= need : count === need;
        off = qualifies ? Math.round((subtotal * pct) / 100) : 0;
      }

      ensureSlots(Math.max(need, count));
      revealLastSlot(count);
      Array.prototype.forEach.call(root.querySelectorAll('[data-ufc-byob-slot]'), function (slot, i) {
        var item = chosen[i];
        slot.classList.toggle('is-filled', !!item);
        slot.innerHTML = item
          ? '<img src="' + item.image + '" alt="" loading="lazy">' +
            '<button class="ufc-byob__slot-remove" type="button" data-ufc-byob-remove="' + i +
            '" aria-label="' + (strings.remove || 'Remove') + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" ' +
            'stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>'
          : '<span aria-hidden="true">+</span>';
      });

      // Each tile reports its own count, so a second tap reads as "now 2".
      Array.prototype.forEach.call(picks, function (button) {
        var n = qtyOf(button.getAttribute('data-variant'));
        button.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
        if (allowQty) {
          var badge = button.querySelector('[data-ufc-byob-pick-qty]');
          if (badge) badge.textContent = n;
          var steps = button.parentNode.querySelector('[data-ufc-byob-pick-steps]');
          if (steps) steps.hidden = n < 1;
          var plus = button.parentNode.querySelector('[data-ufc-byob-pick-plus]');
          if (plus) plus.disabled = !openEnded && chosen.length >= need;
        }
      });

      Array.prototype.forEach.call(tierEls, function (el) {
        var min = parseInt(el.getAttribute('data-ufc-byob-tier'), 10) || 0;
        var active = !!tier && tier.min === min;
        el.classList.toggle('is-active', active);
        el.classList.toggle('is-done', count >= min && !active);
      });

      // The pick tiles quote the product's own price and are not rewritten as
      // rungs are cleared: the bundle's saving belongs to the summary, not to
      // every tile.

      if (countEl) {
        countEl.textContent = ladder || count > need
          ? fill(strings.flatCount, { picked: count })
          : fill(strings.count, { picked: count, count: need });
      }
      if (offLabelEl) {
        // Names the rung actually in force, not the first one on the ladder.
        var shown = tier || tiers[0];
        if (percentLadder) {
          offLabelEl.textContent = fill(strings.percentTierDiscount, {
            qty: shown ? shown.min : need,
            percent: shown ? shown.percent : 0
          });
        } else {
        offLabelEl.textContent = fill(strings.flatDiscount, {
          qty: shown ? shown.min : need,
          // The rung's own formatted text, so this line and the ladder quote the
          // same price rather than one carrying trailing zeros the other drops.
          each: shown ? shown.eachText || money(shown.each, strings.moneyFormat) : ''
        });
        }
      }
      if (subEl) subEl.textContent = money(subtotal, strings.moneyFormat);
      if (offEl) offEl.textContent = '−' + money(off, strings.moneyFormat);
      if (totalEl) totalEl.textContent = money(subtotal - off, strings.moneyFormat);

      if (addBtn) {
        // Flat pricing has no upper bound, so "ready" is a floor, not a match.
        var ready = openEnded ? count >= need : count === need;
        addBtn.disabled = !ready;
        addBtn.textContent = ready
          ? strings.buttonReady
          : fill(strings.buttonLocked, { left: need - count });
      }
    }

    function addUnit(button) {
      // Silently ignoring the click once full would read as broken, so the
      // button simply stays unpressed and the count line explains why. Flat
      // pricing has no ceiling, so nothing to stop there.
      if (!openEnded && chosen.length >= need) return false;
      var img = button.querySelector('img');
      chosen.push({
        id: button.getAttribute('data-variant'),
        price: parseInt(button.getAttribute('data-price'), 10) || 0,
        image: img ? img.currentSrc || img.src : ''
      });
      return true;
    }

    function removeUnit(id) {
      // Last one first, so taking one back undoes the most recent choice and
      // the slot that empties is the one the shopper just filled.
      for (var i = chosen.length - 1; i >= 0; i--) {
        if (chosen[i].id === id) {
          chosen.splice(i, 1);
          return true;
        }
      }
      return false;
    }

    Array.prototype.forEach.call(picks, function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-variant');

        if (allowQty) {
          // With quantities on, a tap always means "one more" -- taking one
          // back is what the minus is for. Toggling here instead would make a
          // second tap wipe the first.
          addUnit(button);
        } else if (qtyOf(id) > 0) {
          removeUnit(id);
        } else {
          addUnit(button);
        }

        sync();
      });
    });

    // The minus lives beside the tile rather than inside it, so it is bound
    // here rather than riding on the tile's own click.
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-ufc-byob-pick-minus]'),
      function (minus) {
        minus.addEventListener('click', function (event) {
          event.preventDefault();
          if (removeUnit(minus.getAttribute('data-ufc-byob-pick-minus'))) sync();
        });
      }
    );

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-ufc-byob-pick-plus]'),
      function (plus) {
        plus.addEventListener('click', function (event) {
          event.preventDefault();
          var id = plus.getAttribute('data-ufc-byob-pick-plus');
          var tile = null;
          Array.prototype.forEach.call(picks, function (button) {
            if (button.getAttribute('data-variant') === id) tile = button;
          });
          if (tile && addUnit(tile)) sync();
        });
      }
    );

    // The cross on a filled slot. Delegated because the slots are rewritten on
    // every sync, so a handler bound to the button would not survive.
    root.addEventListener('click', function (event) {
      var close = event.target.closest ? event.target.closest('[data-ufc-byob-remove]') : null;
      if (!close) return;
      event.preventDefault();
      var at = parseInt(close.getAttribute('data-ufc-byob-remove'), 10);
      var item = chosen[at];
      if (!item) return;
      chosen.splice(at, 1);
      // sync() re-reads every tile's count, so the tile this came from clears
      // only if that was its last unit -- taking one of three back must not
      // unpress a product still in the bundle.
      sync();
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (openEnded ? chosen.length < need : chosen.length !== need) return;

        addBtn.disabled = true;

        // Fold the units back into one line per variant: posting the same id
        // several times over would either error or stack as separate lines.
        var lines = [];
        var seen = {};
        chosen.forEach(function (item) {
          if (seen[item.id] === undefined) {
            seen[item.id] = lines.length;
            lines.push({ id: item.id, quantity: 1 });
          } else {
            lines[seen[item.id]].quantity += 1;
          }
        });

        window
          .ufcAddToCart(lines)
          .then(function () {
            addBtn.textContent = strings.added;
            window.setTimeout(function () {
              chosen = [];
              sync();
            }, 1200);
          })
          .catch(function () {
            addBtn.disabled = false;
          });
      });
    }

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
